import React from "react";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import FunnelChart from "common-ui-components/components/funnel-chart/FunnelChart";
import styles from "./ThreatExposure.module.css";

const ThreatExposure = ({ overview,loading =false }) => {
  const total = Number(overview?.totalVulnerabilities) || 0;
  // TODO: The overview API does not currently provide an exploitable-only count.
  const funnelStages = [
    { id: "total", label: "Total vulnerabilities", value: total, funnelWidth: 0.88, color: "#dce7ff" },
    { id: "Zero day", label: "Zero day", value: Number(overview?.totalZeroDayVulnerabilities), funnelWidth: 0.72, color: "#b7ccfa" },
    { id: "exploited", label: "Actively exploited", value: Number(overview?.totalActivelyExploitedVulnerabilities) || 0, funnelWidth: 0.55, color: "#7fa2f8" },
    {
      id: "kev",
      label: "CISA KEV listed",
      value: Number(overview?.totalCISAKEVListedVulnerabilities) || 0,
      funnelWidth: 0.39,
      color: "#3d6de8",
      labelColor: "#ffffff",
    },
  ].map((stage) => ({
    ...stage,
    percent: total ? (stage.value / total) * 100 : 0,
  }));

  return (
    <InfoBox
      header="Risk Prioritisation by Threat Exposure"
      subtitle="How open vulnerabilities narrow to the most urgent threats"
      style={{ width: "100%", minWidth: 0 }}
    >
      <FunnelChart
        data={funnelStages}
        height={220}
        loading={loading}
        ariaLabel="Open vulnerabilities by threat exposure"
      />
    </InfoBox>
  );
};

export default ThreatExposure;
